export enum ResidentStatus {
    ACTIVE = 1,
    INACTIVE = 2,
}